<template>
  <div class="c-product">
    <section class="container product-large">
      <div class="row" :class="{'done-active': index <= 1}" v-for="(item, index) in productLarge" :key="item.id" ref="smitem">
        <product-item
          :data="item"
          :isScrollMagic=true
          :lineBreak="' / '"
          :isLastItem="index==productLarge.length-1"
          :isLarge=true
          :isAnimation=true
          @parentOnEnter="emitOnEnter"
          @parentOnLeave="emitOnLeave"
        ></product-item>
      </div>
    </section>
    <section class="container product-lm">
      <div class="row" v-for="item in productLM" :key="item.id">
        <product-item
          :data="item"
          :lineBreak="'<br />'"
          :isScrollMagic=true
          :isAnimation=true
        ></product-item>
      </div>
    </section>
    <section class="container product-medium">
      <div class="row">
        <h3 class="section-title">MORE ARCHIVES</h3>
      </div>
      <div class="row">
        <div class="col-6" v-for="item in productMedium" :key="item.id">
          <product-item
            :data="item"
            :lineBreak="' / '"
            :isScrollMagic=true
            :isAnimation=true
          ></product-item>
        </div>
      </div>
    </section>
    <section class="container product-small">
      <div class="row">
        <div class="col-6 col-md-3" v-for="item in productSmall" :key="item.id">
          <product-item
            :data="item"
            :lineBreak="' / '"
            :isScrollMagic=true
            :isAnimation=true
          ></product-item>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ProductItem from '../components/ProductItem'

export default {
  props: {
    data: Array
  },
  components: {
    ProductItem
  },
  methods: {
    emitOnEnter (target) { this.$emit('emitOnEnter', target) },
    emitOnLeave (target) { this.$emit('emitOnLeave', target) }
  },
  computed: {
    productLarge () {
      if (this.data) {
        return this.data.slice(0, 11)
      } else {
        return null
      }
    },
    productLM () {
      if (this.data) {
        return this.data.slice(11, 15)
      } else {
        return null
      }
    },
    productMedium () {
      if (this.data) {
        return this.data.slice(15, 23)
      } else {
        return null
      }
    },
    productSmall () {
      if (this.data) {
        return this.data.slice(23, 9999)
      } else {
        return null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductList.vue